function showCountryTrends()
{
    $('#fifa-trends').hide();
    $('#country-trends').show();
    $('#live-trends').hide();
    $('.trending-tags__list').slick('slickGoTo', 0);
    $('.trending__title--selected').removeClass('trending__title--selected');
    $('#trends-show-country-trends').addClass('trending__title--selected');
}

function showLiveTrends()
{
    $('#fifa-trends').hide();
    $('#live-trends').show();
    $('#country-trends').hide();
    $('.trending-tags__list').slick('slickGoTo', 0);
    $('.trending__title--selected').removeClass('trending__title--selected');
    $('#trends-show-live-trends').addClass('trending__title--selected');
}

function showFifaTrends()
{
    $('#fifa-trends').show();
    $('#live-trends').hide();
    $('#country-trends').hide();

    $('.trending-tags__list').slick('slickGoTo', 0);
    $('.trending__title--selected').removeClass('trending__title--selected');
    $('#trends-show-fifa-trends').addClass('trending__title--selected');
}

$(document).ready(function()
{
    if($('.trending-tags').length > 0)
    {
        fetchTrends();
    }
});

function fetchTrends()
{
    var data =
        {
            from: (typeof document.location.href !== "undefined" ?
                                document.location.href : null),
            videoId: (typeof global_tokyvideo_video_id !== "undefined" ?
                                global_tokyvideo_video_id : null)
        };

    //window['console'].log('fetchTrends');
    //window['console'].dir(data);

    var drawTrends = function( response )
    {
        //window['console'].info('drawTrends');
        //window['console'].dir(response);

        var newHTML,
            hasCountryTrends = false,
            hasLiveTrends = false,
            hasFifaTrends = false,
            total = 0;

        var trendNode = function(t)
        {
            var inc = false;
            var hn = 'www.tokyvideo.com';

            if('string' === typeof window.location.hostname)
            {
                hn = window.location.hostname;
            }

            if('function' === typeof t.url.includes)
            {
                inc = (t.url.includes(hn));
            }
            else if('function' === typeof t.url.indexOf)
            {
                inc = (-1 !== t.url.indexOf(hn))
            }

            var nofollow = (inc ? '' : ' rel=nofollow');
            var node = '<li class="tab__item"><a href="' + t.url + '" ' +
                        'class="tab__link btn btn-primary--light" title="' +
                         t.text + '"' + nofollow + ' rel="tag"';

            if(null !== t.target)
            {
                node += ' target="' + t.target + '"';
            }

            node += '>';

            if( ("undefined" !== typeof t.mobileText) &&
                (null        !== typeof t.mobileText) &&
                (''          != t.mobileText)         &&
                (null        != t.mobileText)            )
            {
                node += '<span class="hide-xs">' + t.text       + '</span>';
                node += '<span class="show-xs">' + t.mobileText + '</span>';
            }
            else
            {
                node += t.text + '</a></li>';
            }

            return node;
        };

        var trendSubList = function(t)
        {

            for (var i= 0; i < t.length - 1; i++) {
                if (t[i].url == window.location.href)
                {
                    t.splice(i, 1);
                    break;
                }
            }
                        
            var firstSubList    = t.slice(0,3);
            var secondSubList   = t.slice(3,6);
            var thirdSubList    = t.slice(6,t.length);

            var list = '<li>';

            if (firstSubList.length > 0) 
            {
                list += '<ul class="tab__block-sublist">';
                for (var i = 0; i < firstSubList.length ; i++)
                    {
                        list += trendNode(firstSubList[i]);
                    }
                list += '</ul>';
            }

            if (secondSubList.length > 0) 
            {
                list += '<ul class="tab__block-sublist">';
                for (var i = 0; i < secondSubList.length ; i++)
                    {
                        list += trendNode(secondSubList[i]);
                    }
                list += '</ul>';
            }

            if (thirdSubList.length > 0) 
            {
                list += '<ul class="tab__block-sublist">';
                for (var i = 0; i < thirdSubList.length ; i++)
                    {
                        list += trendNode(thirdSubList[i]);
                    }
                list += '</ul>';
            }
            
            list += '</li>';
            
            return list;
        };

        // country trends
        if( response.hasOwnProperty('country') && (null !== response.country) &&
            response.hasOwnProperty('trends')  && (null !== response.trends)  &&
            response.trends.hasOwnProperty('country') &&
                                            (null !== response.trends.country) )
        {
            if(response.trends.country.hasOwnProperty('trends'))
            {
                if(response.trends.country.trends.length > 0)
                {
                    var trendList = response.trends.country.trends;

                    if (trendList.length > 0) {                       
                        $('#country-trends ul').append(trendSubList(trendList));
                        hasCountryTrends = true;
                        total += 1;
                    }

                    if($('#trends-show-country-trends').length > 0)
                    {
                        newHTML = $('#trends-show-country-trends').html()
                                    .replace('%trends-callback-country-name%',
                                             response.country);

                        $('#trends-show-country-trends').html(newHTML);
                        //$('#trends-show-country-trends').show();
                        $('#trends-show-country-trends-parent').show();
                    }

                    if( ("undefined" !== typeof response.flag) &&
                        (null !== response.flag)                    )
                    {
                        var image = '<img class="tab__flag" src="' + response.flag +
                                       '" alt="' + response.country + '">';
                        $('#country-trends-country-flag').append(image);
                    }
                }
                if(hasCountryTrends && $('#country-trends ul li').length > 0)
                {
                    /**
                     * inline-block hace que se muestren debajo del botón del tipo
                     * de tendencias
                     */
                    //$('#trends-li-country').css('display', 'inline-block');
                }
                else
                {
                    hasCountryTrends = false;
                }
            }
        }

        // live trends
        if( response.hasOwnProperty('trends')  && (null !== response.trends)  &&
            response.trends.hasOwnProperty('live') &&
                                            (null !== response.trends.live) )
        {
            var trendList = response.trends.live.trends;

            if (trendList.length > 0) 
            {
                $('#live-trends ul').append(trendSubList(trendList));
                hasLiveTrends = true;
                total += 1;
            }

            if(hasLiveTrends && $('#live-trends ul li').length > 0)
            {
                $('#trends-show-live-trends-parent').show();
                /**
                 * inline-block hace que se muestren debajo del botón del tipo
                 * de tendencias
                 */
                $('#trends-li-live').css('display', 'inline-block');
            }
            else
            {
                hasLiveTrends = false;
            }
        }

        // fifa trends
        if( response.hasOwnProperty('trends')  && (null !== response.trends)  &&
            response.trends.hasOwnProperty('fifa') &&
                                            (null !== response.trends.fifa) )
        {
            var trendList = response.trends.fifa.trends;

            if (trendList.length > 0) 
            {
                $('#fifa-trends ul').append(trendSubList(trendList));
                hasFifaTrends = true;
                total += 1;
            }

            if(hasFifaTrends && $('#fifa-trends ul li').length > 0)
            {
                $('#trends-show-fifa-trends-parent').show();
                /**
                 * inline-block hace que se muestren debajo del botón del tipo
                 * de tendencias
                 */
                $('#trends-li-fifa').css('display', 'inline-block');
            }
            else
            {
                hasFifaTrends = false;
            }
        }

        if(hasCountryTrends || hasLiveTrends || hasFifaTrends)
        {
            $('.trending-tags').show();
            $('.trending-tags__items').css('height', 'auto');
            initTrendingMarquee();
        }
        else
        {
            $('.trending-tags').hide();
        }

        /*if(hasFifaTrends)
        {
            showFifaTrends();
        }
        else if(hasLiveTrends)
        {
            showLiveTrends();
        }
        else if(hasCountryTrends)
        {
            showCountryTrends();
        }*/

        //console.log(total);
        switch(total) {
            case 1:
                $('#trends-show-country-trends-parent').addClass('tab__item--section-full');
                break;
            case 2:
                if (hasFifaTrends) {
                    $('#trends-show-fifa-trends-parent').addClass('tab__item--section-half');
                } else {
                    $('#trends-show-live-trends-parent').addClass('tab__item--section-half');
                }
                $('#trends-show-country-trends-parent').addClass('tab__item--section-half');
                break;
            case 3:
                $('.tab__trending-title').addClass('hidden-sm');
                break;
        }

        if(hasFifaTrends)
        {
            //$('#trends-show-fifa-trends').trigger('click');
        }
        else if(hasLiveTrends)
        {
            $('#trends-show-live-trends').trigger('click');
        }
        else if(hasCountryTrends)
        {
            $('#trends-show-country-trends').trigger('click');
        }
    };

    $.ajax(global_tokyvideo_api_url + '/trends/list',
           {
               type:       'POST',
               data:       data,
               success:    drawTrends,
               beforeSend: function (xhr)
               {
                    xhr.setRequestHeader('Accept', 'text/json');
               }
           });
}
